// Unified asset-status vocabulary (Draft / Processing / Ready / Error) shared by
// the dataset header chip and the cohort-picker status chip. Deterministic mirror
// of the backend ``analytical_dataset_to_asset_status`` mapper; PROCESSED is
// terminal-success → Ready.
const ASSET_STATUS_MAP: Record<string, string> = {
  DRAFT: 'DRAFT',
  PROCESSING: 'PROCESSING',
  PROCESSED: 'READY',
  ERROR: 'ERROR',
};

/** Map a raw lifecycle status to the unified asset-status vocabulary. */
export const toAssetStatus = (status: string): string =>
  status ? ASSET_STATUS_MAP[status.toUpperCase()] ?? status : status;

/** Title-case a status for display (e.g. PROCESSED → Processed, READY → Ready). */
export const formatStatusLabel = (status: string): string =>
  status ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() : '';
